import { observer } from 'mobx-react';
import { MouseEvent } from 'react';
import styled from 'styled-components';

// Components
import AccountDropdown from 'components/headers/AccountDropdown';
import { Layout } from 'top-component-library';

// Constants
import breakpoints from 'constants/breakpoints';

// Hooks
import { useStores } from 'hooks/use-stores';

// Tracking
import { bosLandingPageTrackingEvents } from 'integrations/segment/tracking-events';

function LegacyLandingPageHeader() {
  const { hostStore, locationStore } = useStores();
  const { assets } = hostStore;
  const { customerName } = locationStore; // A11Y: Used as logo alt

  const handleTrackClickGoToHome = (e: MouseEvent): void =>
    bosLandingPageTrackingEvents.trackClickCustomerHomeLinkLandingPage({
      href: assets?.home_button_link,
    });

  return (
    <Header>
      <LogoContainer>
        {!!assets?.landing_page_logo && <Logo src={assets?.landing_page_logo} alt={customerName} />}
      </LogoContainer>
      <Links>
        {assets?.home_button_text && assets?.home_button_link && (
          <HomeRedirect href={assets?.home_button_link} onClick={handleTrackClickGoToHome}>
            {assets?.home_button_text}
          </HomeRedirect>
        )}
        <StyledAccountDropdown />
      </Links>
    </Header>
  );
}

export default observer(LegacyLandingPageHeader);

const Header = styled(Layout.Header)`
  align-items: center;
  background-color: transparent;
  display: flex;
  height: auto;
  justify-content: space-between;
  padding: 0.875rem 1rem;
  position: relative;
  z-index: 1;

  @media (min-width: ${breakpoints.md}px) {
    box-shadow: none;
    padding: 1rem 2rem;
  }
`;

const HomeRedirect = styled.a`
  cursor: pointer;
  font-weight: bold;
  position: relative;
`;

const Links = styled.div`
  display: flex;

  & > a,
  span {
    color: #ffffff;
  }

  > div:not(:last-child),
  > a:not(:last-child) {
    margin-right: 1rem;
  }
`;

const LogoContainer = styled.div`
  align-self: flex-start;
`;

const Logo = styled.img`
  align-self: flex-start;
  width: var(--landing-page-logo__width, 100px);
  height: auto;
  object-fit: cover;
  position: relative;
`;

const StyledAccountDropdown = styled(AccountDropdown)`
  &.account-dropdown {
    width: 1.25rem;
    height: 1.25rem;
    border: 1px solid #ffffff;

    &:focus,
    &:hover {
      border-color: var(--color-neutral__title-active);
      color: var(--color-neutral__title-active);

      .anticon {
        color: var(--color-neutral__title-active);
      }
    }

    & > span.anticon {
      font-size: 1rem;
    }
  }

  &.login-link {
    font-size: 1rem;
    color: #ffffff;

    &:hover {
      color: #ffffff;
    }
  }
`;
